import firebase from 'firebase'
import 'firebase/firestore'
import 'firebase/auth'

var config = {
    apiKey: "AIzaSyBGVSEeS7HY26ZWJRLqwML1rL6UFKL0Brg",
    authDomain: "pappatraderavue.firebaseapp.com",
    databaseURL: "https://pappatraderavue.firebaseio.com",
    projectId: "pappatraderavue",
    storageBucket: "",
    messagingSenderId: "883254673400"
};

const firebaseApp = firebase.initializeApp(config);
firebaseApp.firestore().settings({timestampsInSnapshots: true})


export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/Firebase/init.js